module.exports = __webpack_public_path__ + "static/5_poprawki4_papa-b6c3186ff75d3d56d55b8bc26ac9274c.jpg";